const Flickity = require('flickity')

module.exports = {
  initMinSlider: () => {
    const elem = document.querySelector('.carousel')

    if (elem) {
      const flkty = new Flickity(elem, {
        freeScroll: false,
        initialIndex: 0,
        prevNextButtons: false,
        wrapAround: true,
        pageDots: false,
        contain: true,
        autoPlay: true,
      })

      const titleEls = document.querySelectorAll('.slider-title')

      // Add Title click event
      for (const [i, el] of titleEls.entries()) {
        el.addEventListener('click', () => {
          flkty.select(i)
        })
      }

      titleEls[0].classList.add('text-yellow-500')
      titleEls[0].classList.add('border-yellow-500')
      // Update Title Class
      flkty.on('change', () => {
        for (const el of titleEls) {
          if (+el.dataset.index === flkty.selectedIndex) {
            el.classList.remove('border-white')
            el.classList.add('text-yellow-500')
            el.classList.add('border-yellow-500')

          } else {
            el.classList.add('border-white')
            el.classList.remove('text-yellow-500')
            el.classList.remove('border-yellow-500')
          }
        }
      })
    }
  },

  initBaseSliders: () => {
    const flickityOptions = {
      groupCells: '100%',
      freeScroll: false,
      initialIndex: 0,
      prevNextButtons: false,
      wrapAround: false,
      pageDots: true,
      contain: false,
      autoPlay: true,
      draggable: true,
      cellAlign: 'left',
    }

    const elems = document.querySelectorAll('.flickity-carousel')

    for (const el of elems) {
      new Flickity(el, flickityOptions)
    }
  },
}
